<template>
  <v-app>
    <div v-if="authenticated">
    <NavBar/>
    </div>
    <v-main>
      <router-view @authenticated="setAuthenticated"/>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'
import NavBar from '@/components/NavBar'

const API_URL = process.env.VUE_APP_API_URL
const HEARTBEAT_MS = 15000

export default {
  name: 'App',
  components :{

    NavBar
  },
  data(){
    return{
      authenticated:JSON.parse(localStorage.getItem('status')),
      heartbeat: null
    }
  },
   mounted(){
      if(!this.authenticated && this.$route.name !== 'login'){
        this.$router.replace({name:'login'});
      }
      if(this.authenticated){
        this.checkSession()
        this.heartbeat = setInterval(this.checkSession, HEARTBEAT_MS)
      }
    },
  beforeDestroy(){
    if(this.heartbeat) clearInterval(this.heartbeat)
  },
  methods:{
   setAuthenticated(status){
     this.authenticated=status
     if(status && !this.heartbeat){
       this.heartbeat = setInterval(this.checkSession, HEARTBEAT_MS)
     }
   },

   // Verify the account is still active (and still has a district for non-admins)
   async checkSession(){
     let user = {}
     try { user = JSON.parse(localStorage.getItem('user') || '{}') } catch(e){ user = {} }
     if(!user.id) return
     try {
       const res = await axios.post(API_URL, { opcion: 60, user_id: user.id })
       const row = res.data && res.data[0]
       if(!row || row.ok !== true) return // server hiccup — don't kick on errors

       const role = (row.Role || user.role || '').toString().trim().toLowerCase()
       const active = Number(row.status) === 1
       const hasDistrict = !!(row.district && String(row.district).trim())
         || (Array.isArray(row.districts) && row.districts.length > 0)

       if(!active){
         return this.forceLogout('deactivated')
       }
       if(role !== 'admin' && !hasDistrict){
         return this.forceLogout('district')
       }
       // keep local copy fresh (role/district may have changed)
       user.role = role
       user.district = row.district || null
       user.districts = row.districts || []
       localStorage.setItem('user', JSON.stringify(user))
     } catch(e){
       // network error — leave the session alone
     }
   },

   forceLogout(reason){
     if(this.heartbeat){ clearInterval(this.heartbeat); this.heartbeat = null }
     ['status','user','username','fname','usertype'].forEach(k => localStorage.removeItem(k))
     this.authenticated = false
     if(this.$route.name !== 'login'){
       this.$router.replace({ name:'login', query:{ reason } })
     }
   }
  }
};
</script>
